import * as React from 'react';
import { withTranslation  } from 'react-i18next';
import { connect } from 'react-redux';
import {getCollisionDataframes} from 'Redux/Actions/CollisionActions'
import {HistoryCollision} from './HistoryCollision'

type Props = {
    history?:any,
    t?:any,
    match: any;
  };
type ConnectedProps = {};
interface IDispatchedP {
    getCollisionDataframes:(collisionId:number)=>Function
}

export class HistoryCollisionPage extends React.Component<Props & ConnectedProps & IDispatchedP,any> {

    public componentDidMount() {
      const { collisionId } = this.props.match.params;
      this.props.getCollisionDataframes(collisionId);
    }
  
    public render() {
      return (
        <HistoryCollision/>
      );
    }
}

function mapDispachToProps(dispatch: any): IDispatchedP {
    return {
      getCollisionDataframes:(collisionId:number)=>dispatch(getCollisionDataframes(collisionId))
    }
}
  
export default withTranslation ()(connect(
    null,
    mapDispachToProps
)(HistoryCollisionPage) as React.ComponentClass<any>);



// WEBPACK FOOTER //
// ./src/components/History/HistoryCollisionPage.tsx